var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTrackersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.484,
    height: 100.075,
    viewBox: "0 0 101.484 100.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1397",
    "data-name": "Grupo 1397",
    transform: "translate(-530.992 -529.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_off_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M93.627-788.219a13.133,13.133,0,0,1-9.641-3.986A13.133,13.133,0,0,1,80-801.846a13.133,13.133,0,0,1,3.986-9.641,13.133,13.133,0,0,1,9.641-3.986,13.133,13.133,0,0,1,9.641,3.986,13.133,13.133,0,0,1,3.986,9.641,13.133,13.133,0,0,1-3.986,9.641A13.133,13.133,0,0,1,93.627-788.219Zm37.064-2.725-17.442-17.442q-.818-.886-1.737-1.806t-1.806-1.737a12.348,12.348,0,0,0,4.156-4.36,11.816,11.816,0,0,0,1.567-6,11.827,11.827,0,0,0-3.577-8.687,11.827,11.827,0,0,0-8.687-3.577,11.827,11.827,0,0,0-8.687,3.577,11.827,11.827,0,0,0-3.577,8.687q0,.409.034.784t.1.784a17.145,17.145,0,0,0-2.691.545,16.736,16.736,0,0,0-2.623.954q-.136-.75-.2-1.5t-.068-1.567a17.1,17.1,0,0,1,5.144-12.571A17.1,17.1,0,0,1,103.165-840a17.1,17.1,0,0,1,12.571,5.144,17.1,17.1,0,0,1,5.144,12.571,16.659,16.659,0,0,1-.92,5.553,17.735,17.735,0,0,1-2.555,4.8l17.1,17.169Zm-41.9-4.156,4.837-4.837L98.4-795.1l1.976-1.908-4.837-4.837,4.837-4.838-1.908-1.908-4.837,4.837-4.837-4.837-1.908,1.908,4.837,4.838-4.837,4.837Z",
    transform: "translate(497.97 1418.219)",
    fill: "#22638d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "query_stats_24dp_FILL1_wght400_GRAD0_opsz24",
    d: "M47.274-807.6,40-812.857l22.381-35.811L75.81-833l17.9-29.095,12.2,18.24a28.293,28.293,0,0,0-4.868.616,28.769,28.769,0,0,0-4.532,1.4l-2.462-3.693-17.01,27.64L63.5-833.672Zm70.164-34.017a29.282,29.282,0,0,0-4.42-1.456,24.739,24.739,0,0,0-4.756-.671L131.2-880l7.274,5.26Z",
    transform: "translate(493 1416)",
    fill: "#d2e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "query_stats_24dp_FILL1_wght400_GRAD0_opsz24-2",
    "data-name": "query_stats_24dp_FILL1_wght400_GRAD0_opsz24",
    d: "M47.274-807.6,40-812.857l22.381-35.811L75.81-833l17.9-29.095,12.2,18.24a28.293,28.293,0,0,0-4.868.616,28.769,28.769,0,0,0-4.532,1.4l-2.462-3.693-17.01,27.64L63.5-833.672Zm70.164-34.017a29.282,29.282,0,0,0-4.42-1.456,24.739,24.739,0,0,0-4.756-.671L131.2-880l7.274,5.26Z",
    transform: "translate(492 1411)",
    fill: "none",
    stroke: "#bcd0dc",
    strokeWidth: 1.5,
    strokeDasharray: "5 6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTrackersIcon);
export default __webpack_public_path__ + "static/media/noTrackersIcon.2306a24704b29b0c99f728e7f47e50f5.svg";
export { ForwardRef as ReactComponent };